import React from 'react';
import { t } from 'i18next';

const PageNotExists = () => <div>{ t('common:pageDoesNotExist') }</div>

export default PageNotExists;
